module.exports = __webpack_public_path__ + "static/media/RCMCertifiedProgram_Generic_WHITE.5bde1173.svg";